export default __webpack_public_path__ + "static/media/depot-reminder.51ff5a40.svg";